export default "__VITE_ASSET__DzDxIRni__"